import { render } from "./medication.vue?vue&type=template&id=5b7c0e88&scoped=true"
import script from "./medication.vue?vue&type=script&lang=js"
export * from "./medication.vue?vue&type=script&lang=js"

import "./medication.vue?vue&type=style&index=0&id=5b7c0e88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7c0e88"]])

export default __exports__